<sa-header></sa-header>

<sa-navigation></sa-navigation>

<div id="main" role="main" [@routerTransition]="o?.isActivated ? getState(o) : ''">
  <sa-ribbon></sa-ribbon>
  <router-outlet #o="outlet"></router-outlet>
</div>

<sa-footer></sa-footer>